import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class TreasurePieceConfig extends Cloneable {

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(TreasurePieceConfig, v) : SKIP;
        }, (v) => {
            return deserialize(TreasurePieceConfig, v);
        });
    }

    constructor() {
        super();

        this._key = null;
        this._amount = 0;
        this._percent = 0;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get amount() {
        return this._amount;
    }

    set amount(value) {
        this._amount = value;
    }

    get percent() {
        return this._percent;
    }

    set percent(value) {
        this._percent = value;
    }

    valid() {
        if (!Number.isInteger(this.amount) || this.amount < 0) {
            return false;
        }

        if (!Number.isInteger(this.percent) || this.percent <= 0 || this.percent > 100) {
            return false;
        }

        return true;
    }

    empty() {
        return this.percent === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TreasurePieceConfig());
        } else if (target instanceof TreasurePieceConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TreasurePieceConfig, {
    _key: alias("key", Schema.primitive()),
    _amount: alias("amount", Schema.primitive()),
    _percent: alias("percent", Schema.primitive())
});